import { render, staticRenderFns } from "./Viewartworks.vue?vue&type=template&id=4e706617"
import script from "./Viewartworks.vue?vue&type=script&lang=js"
export * from "./Viewartworks.vue?vue&type=script&lang=js"
import style0 from "./Viewartworks.vue?vue&type=style&index=0&id=4e706617&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports